// Charolas para cocina a partir de los combos del wizard.
//
// Cada combo es una charola con la MISMA forma que arma el punto de venta
// (management/src/Utils/packing.js): platillo + guarniciones (categoría 2) con
// sus precios y el combo al que pertenece; la bebida o el postre del combo van
// como suelto LIGADO a esa charola (`linkedToCharola`), no como guarnición.
// Antes se mandaba todo lo que no era platillo como guarnición y sin precios:
// el backend dejaba los totales en $0 y, si el pedido se editaba en Cocina, la
// charola se valoraba sin combo (pedido #25290: $159 en vez de $124).

const CAT_PLATILLO = 1;
const CAT_COMPLEMENTO = 2;

const numero = (v) => Number(v) || 0;

/**
 * @param {Array<{meta: object, items: Array}>} comboGroups  grupos del carrito (CartContext.getComboGroups)
 * @param {number} desde  cuántas charolas van antes en el packing (para numerar las ligas)
 * @returns {{charolas: Array, sueltos: Array}}
 */
export function charolasDeCombos(comboGroups, desde = 0) {
  const charolas = [];
  const sueltos = [];
  (comboGroups || []).forEach((group) => {
    const items = group.items || [];
    if (items.length === 0) return;
    const main = items.find((it) => Number(it.categoryId) === CAT_PLATILLO) || items[0];
    const resto = items.filter((it) => it !== main);
    const sides = resto.filter((it) => Number(it.categoryId) === CAT_COMPLEMENTO);
    const extras = resto.filter((it) => Number(it.categoryId) !== CAT_COMPLEMENTO);
    const individualSum = items.reduce((sum, it) => sum + numero(it.price), 0);
    const meta = group.meta || {};
    // "Plato" sin descuento: se cobra la suma de sus partes y no es combo.
    const esCombo = !meta.noDiscount && meta.price != null;
    const precio = esCombo ? numero(meta.price) : individualSum;
    const numeroCharola = desde + charolas.length + 1;

    charolas.push({
      main: main.id,
      main_name: main.title,
      main_price: numero(main.price),
      main_applyPromotions: Number(main.applyPromotions ?? 1),
      sides: sides.map((s) => s.id),
      sides_names: sides.map((s) => s.title),
      sides_prices: sides.map((s) => numero(s.price)),
      sides_applyPromotions: sides.map((s) => Number(s.applyPromotions ?? 1)),
      individualSum,
      comboPrice: esCombo ? precio : null,
      promoId: esCombo ? meta.comboId ?? null : null,
      promoName: esCombo ? meta.name || null : null,
      finalPrice: precio,
    });
    extras.forEach((it) => {
      sueltos.push({
        id: it.id,
        name: it.title,
        categoryId: Number(it.categoryId),
        price: numero(it.price),
        applyPromotions: Number(it.applyPromotions ?? 1),
        presentation: it.presentation || 'porcion',
        presentationLabel: it.presentationLabel || null,
        qty: it.qty ?? null,
        unit: it.unit ?? null,
        linkedToCharola: numeroCharola,
      });
    });
  });
  return { charolas, sueltos };
}

/** Totales de un packing ya armado; mismo cálculo que el panel (armarPacking). */
export function totalesDePacking(charolas, sueltos) {
  const charolasTotal = charolas.reduce((sum, ch) => sum + numero(ch.finalPrice), 0);
  const sueltosTotal = sueltos
    .filter((s) => s.linkedToCharola == null)
    .reduce((sum, s) => sum + numero(s.price), 0);
  const individualTotal = charolas.reduce((sum, ch) => sum + numero(ch.individualSum), 0) + sueltosTotal;
  return {
    charolasTotal,
    sueltosTotal,
    packingTotal: charolasTotal + sueltosTotal,
    individualTotal,
    savings: Math.max(0, individualTotal - (charolasTotal + sueltosTotal)),
    hasCombos: charolas.some((ch) => ch.comboPrice != null),
  };
}
